module.exports = __webpack_public_path__ + "static/Roostr1-d32679a6d1ae6ef195785af23499c713.png";